export default {
  methods : {
    async RESTResultResultValidationGuard(results, exceptionStatus = [], greenStatus = [200, 201]){
      let validationResult = false;

      if(typeof results.status !== 'undefined'){
        if(greenStatus.includes(results.status)){
          return true;
        }

        if(exceptionStatus.includes(results.status)){
          return false;
        }
      }

      if(validationResult === false){
        switch(results.status){
          case 401:
            await this.handleRequestValidationError('authentication');
          break;

          case 403:
            await this.handleRequestValidationError('emailUnCertificated');
          break;

          case 503:
          case 500:
            if(results.data?.message === 'Service Unavailable'){
              await this.handleRequestValidationError('ServiceUnavailable');
            }
          break;

          default:
            await this.handleRequestValidationError('default');
          break;
        }
      }

      return validationResult;
    }
  }
}
